import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { WidgetConfiguration } from '../../../widget-configs/models/widget-configuration';
import { IColumnDefinition } from '@common/models/column-definition';

@Component({
  selector: 'mojo-widget-table',
  templateUrl: './widget-table.component.html'
})
export class WidgetTableComponent implements OnInit {


  @Input()
  widgetConfigurations: WidgetConfiguration[] = [];
  @Input()
  loading: boolean = false;
  @Output()
  onRowClicked = new EventEmitter<WidgetConfiguration>();

  columns: Array<IColumnDefinition> = [
    { Header: 'Name', Field: 'name' },
    { Header: 'Type', Field: 'widgetTypeId' },
    { Header: 'Description', Field: 'description' },
    { Header: 'Category', Field: 'type' }
  ];

  ngOnInit() {
  }

  showDialogToAdd() {
  }

  onRowSelect(config: WidgetConfiguration) {
    this.onRowClicked.emit(config);
  }

  getGlobalFilterFields(): string[] {
    return this.columns.map(h => h.Field);
  }
}
